import React from 'react';
import { observer } from 'mobx-react';
import $app from 'app/stores/$app';
import { ReactComponent as InfobloxMarkSvg } from 'app/assets/logos/infoblox-mark.svg';
import { ReactComponent as InfobloxMarkDarkSvg } from 'app/assets/logos/infoblox-mark-dark.svg';
import { ReactComponent as InfobloxWordmarkSvg } from 'app/assets/logos/infoblox-wordmark.svg';
import { ReactComponent as InfobloxWordmarkDarkSvg } from 'app/assets/logos/infoblox-wordmark-dark.svg';

export const InfobloxLogo = observer(({ size = 16, ...props }) => {
  const Svg = $app.darkThemeEnabled ? InfobloxMarkDarkSvg : InfobloxMarkSvg;

  return <Svg width={size} height={size} style={{ minWidth: size, minHeight: size }} {...props} />;
});

// viewBox is 422.23 x 92.8.
const WORDMARK_ASPECT_RATIO = 4.55;

export const InfobloxWordmark = observer(({ height = 16, ...props }) => {
  const Svg = $app.darkThemeEnabled ? InfobloxWordmarkDarkSvg : InfobloxWordmarkSvg;

  return (
    <Svg
      width={Math.round(height * WORDMARK_ASPECT_RATIO)}
      height={height}
      role="img"
      aria-label="Infoblox"
      {...props}
    />
  );
});
